const APIConstants = {
    //Endpoints
    ENDPOINT_CONTACT_US: 'api/contact',
    ENDPOINT_CONTACT_US_LIST: 'api/contact/list',
    ENDPOINT_APPOINTMENT_BOOKING: 'api/appointment',
    ENDPOINT_APPOINTMENT_BOOKING_LIST: 'api/appointment/list',
    ENDPOINT_APPOINTMENT_BOOKED_TIME_SLOTS: 'api/appointment/booked-slots',
    ENDPOINT_APPOINTMENT_AVAILABLE_TIME_PERIOD: 'api/appointment/available-slots',
    ENDPOINT_MENU: 'api/menu',
    ENDPOINT_SUBMENU_LIST: 'api/menu/submenu',
    ENDPOINT_PLATFORM: 'api/menu/platforms',
    ENDPOINT_RECOMMENDATION: 'api/aws/recommendations',
    ENDPOINT_RECOMMENDATION_HISTORY: 'api/aws/recommendations-history',
    ENDPOINT_REGISTRATION: 'api/auth/register',
    ENDPOINT_LOGIN: 'api/auth/login',
    ENDPOINT_FORGOT_PASSWORD: 'api/auth/forgot-password',
    ENDPOINT_RESET_PASSWORD: 'api/auth/reset-password',
    ENDPOINT_VERIFY_EMAIL: 'api/auth/verify-email',
    ENDPOINT_RESEND_EMAIL_LINK: 'api/auth/email-verification',
    ENDPOINT_USER_DETAILS: 'api/user',
    ENDPOINT_ACCOUNT_VALIDATE: 'api/user/account-link',
    ENDPOINT_AZURE_INIT_ONBOARDING: 'api/azure/onboarding',
    ENDPOINT_AZURE_ONBOARDING_STATUS: 'api/azure/onboarding-status',
    ENDPOINT_AZURE_ONBOARDING_SUBSCRIPTION_LIST: 'api/azure/list-subscriptions',
    ENDPOINT_AZURE_ONBOARDING_DETAILS: 'api/azure/setup',
    ENDPOINT_AZURE_ONBOARDING_ROLES: 'api/azure/roles',

    ENDPOINT_SUBSCRIPTION_PLANS: 'api/subscription/list',
    ENDPOINT_BUY_SUBSCRIPTION_PLAN: 'api/subscription/user-subscription',
    ENDPOINT_SUBSCRIPTION: 'api/subscription',
    ENDPOINT_CREATE_SUBSCRIPTION: 'api/subscription/create-subscription',
    ENDPOINT_VERIFY_SUBSCRIPTION: 'api/subscription/verify',
    ENDPOINT_BUY_NEW_SUBSCRIPTION: 'api/subscription/create',
    ENDPOINT_ACTIVATE_SUBSCRIPTION: 'api/subscription/activate',
    ENDPOINT_CANCEL_SUBSCRIPTION: 'api/subscription/cancel',

    ENDPOINT_SECURITY_SCAN: 'api/security/scan',
    ENDPOINT_SECURITY_SCAN_REPORT: 'api/security/scan-list',
    ENDPOINT_SECURITY_SCAN_REPORT_LIST: 'api/security/scan-list-names',

    ENDPOINT_GLOBAL_SCAN: 'api/security/global-scan',
    ENDPOINT_GLOBAL_SCAN_RESULT: 'api/security/global-scan-list',
    ENDPOINT_GLOBAL_SCAN_PARSED_RESULT: 'api/security/parse-global-scan',

    ENDPOINT_AWS_FILTER_TAG:'api/aws/get-tags',
    ENDPOINT_INVENTORY_EC2:'api/inventory/ec2',
    ENDPOINT_INVENTORY_EC2_ACTIVTY_EVENTS:'api/inventory/ec2/get-events',
    ENDPOINT_INVENTORY_EC2_SCHEDULED_EVENTS_LIST:'api/inventory/ec2/upcomming-schedule',
    ENDPOINT_INVENTORY_EC2_DELETE_SCHEDULED_EVENTS:'api/inventory/ec2/delete-schedule',
    ENDPOINT_INVENTORY_EC2_BY_DATE:'api/inventory/ec2/by-date', // not in use currently
    ENDPOINT_INVENTORY_EC2_ALL_EVENT_COST:'api/inventory/ec2/all-event-costing',
    ENDPOINT_INVENTORY_EC2_CHANGES:'api/inventory/ec2/changes',
    ENDPOINT_INVENTORY_EC2_EVENTS:'api/inventory/ec2/events',
    ENDPOINT_INVENTORY_EC2_SCHEDULE_EVENTS:'api/inventory/ec2/schedule-event',
    ENDPOINT_INVENTORY_EC2_SCHEDULE_IDLE_SAVE:'api/inventory/ec2/schedule-idle',
    ENDPOINT_INVENTORY_EC2_IDLE_EVENT_LIST:'api/inventory/ec2/upcomming-idle-schedule',
    ENDPOINT_INVENTORY_EC2_SCHEDULE_IDLE_UPDATE:'api/inventory/ec2/update-idle-schedule',
    ENDPOINT_INVENTORY_EC2_SCHEDULE_IDLE_DELETE:'api/inventory/ec2/delete-idle-schedule',

    ENDPOINT_INVENTORY_RDS:'api/inventory/rds',
    ENDPOINT_INVENTORY_RDS_ACTIVTY_EVENTS:'api/inventory/rds/get-events',
    ENDPOINT_INVENTORY_RDS_SCHEDULED_EVENTS_LIST:'api/inventory/rds/upcomming-schedule',
    ENDPOINT_INVENTORY_RDS_DELETE_SCHEDULED_EVENTS:'api/inventory/rds/delete-schedule',
    ENDPOINT_INVENTORY_RDS_BY_DATE:'api/inventory/rds/by-date', // not in use currently
    ENDPOINT_INVENTORY_RDS_ALL_EVENT_COST:'api/inventory/rds/all-event-costing',
    ENDPOINT_INVENTORY_RDS_CHANGES:'api/inventory/rds/changes',
    ENDPOINT_INVENTORY_RDS_EVENTS:'api/inventory/rds/events',
    ENDPOINT_INVENTORY_RDS_SCHEDULE_EVENTS:'api/inventory/rds/schedule-event',
    ENDPOINT_INVENTORY_RDS_SCHEDULE_IDLE_SAVE:'api/inventory/rds/schedule-idle',
    ENDPOINT_INVENTORY_RDS_IDLE_EVENT_LIST:'api/inventory/rds/upcomming-idle-schedule',
    ENDPOINT_INVENTORY_RDS_SCHEDULE_IDLE_UPDATE:'api/inventory/rds/update-idle-schedule',
    ENDPOINT_INVENTORY_RDS_SCHEDULE_IDLE_DELETE:'api/inventory/rds/delete-idle-schedule',

    ENDPOINT_INVENTORY_ASG:'api/inventory/asg',
    ENDPOINT_INVENTORY_ASG_ACTIVTY_EVENTS:'api/inventory/asg/get-events',
    ENDPOINT_INVENTORY_ASG_EVENTS:'api/inventory/asg/events',
    ENDPOINT_INVENTORY_ASG_SCHEDULED_EVENTS_LIST:'api/inventory/asg/upcomming-schedule',
    ENDPOINT_INVENTORY_ASG_SCHEDULE_EVENTS:'api/inventory/asg/schedule-event',
    ENDPOINT_INVENTORY_ASG_DELETE_SCHEDULED_EVENTS:'api/inventory/asg/delete-schedule',
    ENDPOINT_INVENTORY_ASG_ALL_EVENT_COST:'api/inventory/asg/all-event-costing',
    ENDPOINT_INVENTORY_ASG_CHANGES:'api/inventory/asg/changes',

    ENDPOINT_INVENTORY_EBS_CHANGES:'api/inventory/ebs/changes',
    ENDPOINT_INVENTORY_EBS : 'api/inventory/ebs',
    ENDPOINT_INVENTORY_EBS_ON_DEMAND_PRICE:'api/inventory/ebs/ondemandprice',
    
    ENDPOINT_INVENTORY_LAMBDA:'api/inventory/lambda',
    ENDPOINT_INVENTORY_LAMBDA_CHANGES:'api/inventory/lambda/changes',
    
    ENDPOINT_INVENTORY_SAVE_DATA:'api/inventory/aws/save',

    ENDPOINT_INVENTORY_TAG_INSTANT_ACTION:'api/inventory/tag/save-events',
    ENDPOINT_INVENTORY_TAG_SCHEDULED_EVENTS_LIST:'api/inventory/tag/upcomming-schedule',
    ENDPOINT_INVENTORY_TAG_DELETE_SCHEDULED_EVENTS:'api/inventory/tag/delete-schedule',
    ENDPOINT_INVENTORY_TAG_SCHEDULE_EVENTS:'api/inventory/tag/schedule-event',
    ENDPOINT_INVENTORY_TAG_UNTAGGED_INSTANCES:'api/inventory/tag/untagged-resources',
    ENDPOINT_INVENTORY_TAG_RESOURCES_BY_TAGS:'api/inventory/tag/resources-by-tags',
    ENDPOINT_INVENTORY_TAG_ALL_EVENT_COST:'api/inventory/tag/all-event-costing',

    ENDPOINT_AZURE_FILTER_TAG:'api/azure/get-tags',
    // ENDPOINT_INVENTORY_TAG_INSTANT_ACTION:'api/inventory/tag/save-events',
    // ENDPOINT_INVENTORY_TAG_SCHEDULED_EVENTS_LIST:'api/inventory/tag/upcomming-schedule',
    // ENDPOINT_INVENTORY_TAG_DELETE_SCHEDULED_EVENTS:'api/inventory/tag/delete-schedule',
    // ENDPOINT_INVENTORY_TAG_SCHEDULE_EVENTS:'api/inventory/tag/schedule-event',
    // ENDPOINT_INVENTORY_TAG_UNTAGGED_INSTANCES:'api/inventory/tag/untagged-resources',

    ENDPOINT_USER_INVOICE:'api/subscription/history',
    ENDPOINT_USERS:'api/user/get-users',
    ENDPOINT_ADD_USER:'api/user/add-user',
    ENDPOINT_EDIT_USER:'api/user/update-user',

    ENDPOINT_DASHBOARD_CAPTURE:'api/dashboard-capture',
    ENDPOINT_CONNECTION_LIST:'api/connection/get-connections',
    ENDPOINT_ADD_CONNECTION:'api/connection/configure',
    ENDPOINT_DEPLOY_SERVICE:'api/connection/deploy-service',
    ENDPOINT_DEPLOY_SERVICE_LOGS:'api/connection/job-output',
    ENDPOINT_EXECUTE_COMMAND:'api/connection/execute-command',
    ENDPOINT_EXECUTE_COMMAND_LOGS:'api/connection/adhoc-job-output',
    ENDPOINT_LOGS_LIST:'api/connection/all-jobs',
    ENDPOINT_CONNECTION_SERVICE_LIST:'api/connection/services',
    ENDPOINT_DEVOPS_MONITORING_LIST:'api/connection/monitorings',

    ENDPOINT_ROI_SAVING_PLANS:'api/aws/savings-plans',

    ENDPOINT_NOTIFICATION_SETTINGS:'api/notification',
    ENDPOINT_NOTIFICATION_SLACK_WEBHOOK:'api/notification/slack-webhook-list',
    ENDPOINT_NOTIFICATION_SLACK_WEBHOOK_SAVE:'api/notification/save-slack-webhook',
    ENDPOINT_NOTIFICATION_SLACK_WEBHOOK_DELETE:'api/notification/delete-slack-webhook',
    ENDPOINT_NOTIFICATION_SLACK_WEBHOOK_UPDATE:'api/notification/update-slack-webhook',

    ENDPOINT_PRICE_CALCULATOR_EC2_FILTERS:'api/costing/ec2-info',
    ENDPOINT_PRICE_CALCULATOR_EC2_PRICE_LIST:'api/costing/ec2',
    ENDPOINT_PRICE_CALCULATOR_RDS_FILTERS:'api/costing/rds-info',
    ENDPOINT_PRICE_CALCULATOR_RDS_PRICE_LIST:'api/costing/rds',
    ENDPOINT_PRICE_CALCULATOR_S3_FILTERS:'api/costing/s3-info',
    ENDPOINT_PRICE_CALCULATOR_S3_PRICE_LIST:'api/costing/s3',
    ENDPOINT_PRICE_CALCULATOR_EBS_FILTERS:'api/costing/ebs-info',
    ENDPOINT_PRICE_CALCULATOR_EBS_PRICE_LIST:'api/costing/ebs',

    ENDPOINT_K8S_CLUSTERS_DATA:'api/eks/get-clusters-info',
    ENDPOINT_K8S_CLUSTERS_NAMESPACE_DATA:'api/eks/eks-opencost-info',
    ENDPOINT_K8S_CLUSTERS_LOAD_BALANCER_DATA:'api/eks/eks-loadbalancer-info',
    ENDPOINT_K8S_CLUSTERS_EDIT_OPEN_COST:'api/eks/upsert-opencost-url',
    ENDPOINT_K8S_CLUSTERS_DELETE_OPEN_COST:'api/eks/delete-opencost-url',

    ENDPOINT_AZURE_K8S_CLUSTERS_DATA: 'api/aks/get-clusters-info',
    ENDPOINT_AZURE_K8S_CLUSTERS_NAMESPACE_DATA: 'api/aks/aks-opencost-info',
    ENDPOINT_AZURE_K8S_CLUSTERS_LOAD_BALANCER_DATA: 'api/aks/aks-loadbalancer-info',
    ENDPOINT_AZURE_K8S_GET_OPENCOST_URL: 'api/aks/get-opencost-url',
    ENDPOINT_AZURE_K8S_EDIT_OPENCOST_URL: 'api/aks/upsert-opencost-url',
    ENDPOINT_AZURE_K8S_DELETE_OPENCOST_URL: 'api/aks/delete-opencost-url',
    
    ENDPOINT_AZURE_RECOMMENDATION: 'api/azure/recommendations',

    ENDPOINT_AZURE_INVENTORY_VM:'api/inventory/vm',
    ENDPOINT_AZURE_INVENTORY_VM_SCHEDULE_EVENTS:'api/inventory/vm/schedule-event',
    ENDPOINT_AZURE_INVENTORY_VM_SCHEDULED_EVENT_LIST:'api/inventory/vm/upcomming-schedule',
    ENDPOINT_AZURE_INVENTORY_VM_DELETE_SCHEDULED_EVENT:'api/inventory/vm/delete-schedule',
    ENDPOINT_AZURE_INVENTORY_VM_INSTANT_SCHEDULE_EVENT:'api/inventory/vm/save-events',
    ENDPOINT_AZURE_INVENTORY_VM_ALL_EVENT_COST:'api/inventory/vm/all-event-costing',
    ENDPOINT_AZURE_INVENTORY_VM_SCHEDULE_IDLE_SAVE:'api/inventory/vm/schedule-idle',
    ENDPOINT_AZURE_INVENTORY_VM_IDLE_EVENT_LIST:'api/inventory/vm/upcomming-idle-schedule',
    ENDPOINT_AZURE_INVENTORY_VM_SCHEDULE_IDLE_UPDATE:'api/inventory/vm/update-idle-schedule',
    ENDPOINT_AZURE_INVENTORY_VM_SCHEDULE_IDLE_DELETE:'api/inventory/vm/delete-idle-schedule',
    ENDPOINT_AZURE_INVENTORY_VM_ACTIVTY_EVENTS:'api/inventory/vm/get-events',

    ENDPOINT_AZURE_INVENTORY_VMSS:'api/inventory/vmss',
    ENDPOINT_AZURE_INVENTORY_VMSS_SCHEDULE_EVENTS:'api/inventory/vmss/schedule-event',
    ENDPOINT_AZURE_INVENTORY_VMSS_SCHEDULED_EVENT_LIST:'api/inventory/vmss/upcomming-schedule',
    ENDPOINT_AZURE_INVENTORY_VMSS_DELETE_SCHEDULED_EVENT:'api/inventory/vmss/delete-schedule',
    ENDPOINT_AZURE_INVENTORY_VMSS_INSTANT_SCHEDULE_EVENT:'api/inventory/vmss/save-events',
    ENDPOINT_AZURE_INVENTORY_VMSS_ALL_EVENT_COST:'api/inventory/vmss/all-event-costing',
    ENDPOINT_AZURE_INVENTORY_VMSS_SCHEDULE_IDLE_SAVE:'api/inventory/vmss/schedule-idle',
    ENDPOINT_AZURE_INVENTORY_VMSS_IDLE_EVENT_LIST:'api/inventory/vmss/upcomming-idle-schedule',
    ENDPOINT_AZURE_INVENTORY_VMSS_SCHEDULE_IDLE_UPDATE:'api/inventory/vmss/update-idle-schedule',
    ENDPOINT_AZURE_INVENTORY_VMSS_SCHEDULE_IDLE_DELETE:'api/inventory/vmss/delete-idle-schedule',
    ENDPOINT_AZURE_INVENTORY_VMSS_ACTIVTY_EVENTS:'api/inventory/vmss/get-events',

    ENDPOINT_AZURE_INVENTORY_DB:'api/inventory/db',
    ENDPOINT_AZURE_INVENTORY_DB_SCHEDULE_EVENTS:'api/inventory/db/schedule-event',
    ENDPOINT_AZURE_INVENTORY_DB_SCHEDULED_EVENT_LIST:'api/inventory/db/upcomming-schedule',
    ENDPOINT_AZURE_INVENTORY_DB_DELETE_SCHEDULED_EVENT:'api/inventory/db/delete-schedule',
    ENDPOINT_AZURE_INVENTORY_DB_INSTANT_SCHEDULE_EVENT:'api/inventory/db/save-events',
    ENDPOINT_AZURE_INVENTORY_DB_ALL_EVENT_COST:'api/inventory/db/all-event-costing',
    ENDPOINT_AZURE_INVENTORY_DB_SCHEDULE_IDLE_SAVE:'api/inventory/db/schedule-idle',
    ENDPOINT_AZURE_INVENTORY_DB_IDLE_EVENT_LIST:'api/inventory/db/upcomming-idle-schedule',
    ENDPOINT_AZURE_INVENTORY_DB_SCHEDULE_IDLE_UPDATE:'api/inventory/db/update-idle-schedule',
    ENDPOINT_AZURE_INVENTORY_DB_SCHEDULE_IDLE_DELETE:'api/inventory/db/delete-idle-schedule',
    ENDPOINT_AZURE_INVENTORY_DB_ACTIVTY_EVENTS:'api/inventory/db/get-events',

    ENDPOINT_AZURE_ROI_SAVING_PLANS:'api/azure/savings-plans',

    ENDPOINT_GET_TAG_PERMISSIONS:'api/user/get-tag-permissions',
    ENDPOINT_UPSERT_TAG_PERMISSIONS:'api/user/upsert-permissions',
    ENDPOINT_DELETE_TAG_PERMISSIONS:'api/user/delete-tag-permissions',

    ENDPOINT_UPSERT_SERVICE_PERMISSIONS:'api/user/upsert-service-permissions',

    ENDPOINT_AI_CHATBOT_ASK: 'api/ai/ask-ai',
    ENDPOINT_AI_CHATBOT_CHAT_HISTORY: 'api/ai/get-chat',
    ENDPOINT_AI_CHATBOT_ACCESS_KEYS: 'api/user/ai-access-keys',
};
  
export default APIConstants;